import { ReactComponent as CubeScanBulk } from './bulk/3d-cube-scan.svg';
import { ReactComponent as ArrangeSquare2Bulk } from './bulk/arrange-square-2.svg';
import { ReactComponent as BankBulk } from './bulk/bank.svg';
import { ReactComponent as BubbleBulk } from './bulk/bubble.svg';
import { ReactComponent as BuildingBulk } from './bulk/building.svg';
import { ReactComponent as CloudAddBulk } from './bulk/cloud-add.svg';
import { ReactComponent as CoinBulk } from './bulk/coin.svg';
import { ReactComponent as CourthouseBulk } from './bulk/courthouse.svg';
import { ReactComponent as DangerBulk } from './bulk/danger.svg';
import { ReactComponent as DiscountCircleBulk } from './bulk/discount-circle.svg';
import { ReactComponent as DollarCircleBulk } from './bulk/dollar-circle.svg';
import { ReactComponent as EmptyWalletTransparentBulk } from './bulk/empty-wallet-transparent.svg';
import { ReactComponent as EmptyWalletBulk } from './bulk/empty-wallet.svg';
import { ReactComponent as HomeTranspBulk } from './bulk/home-transp.svg';
import { ReactComponent as HomeBulk } from './bulk/home.svg';
import { ReactComponent as LocationBulk } from './bulk/location.svg';
import { ReactComponent as MessagesBulk } from './bulk/messages.svg';
import { ReactComponent as MobileBulk } from './bulk/mobile.svg';
import { ReactComponent as Money3Bulk } from './bulk/money-3.svg';
import { ReactComponent as MoneysBulk } from './bulk/moneys.svg';
import { ReactComponent as MonitorMobbile1Bulk } from './bulk/monitor-mobbile-1.svg';
import { ReactComponent as MonitorMobbileBulk } from './bulk/monitor-mobbile.svg';
import { ReactComponent as NotificationStatusBulk } from './bulk/notification-status.svg';
import { ReactComponent as PersonalcardBulk } from './bulk/personalcard.svg';
import { ReactComponent as Profile2userBulk } from './bulk/profile-2user.svg';
import { ReactComponent as ProfileCircleTransparentBulk } from './bulk/profile-circle-transparent.svg';
import { ReactComponent as ProfileCircleBulk } from './bulk/profile-circle.svg';
import { ReactComponent as ProfileBulk } from './bulk/profile.svg';
import { ReactComponent as ProgrammingArrowsBulk } from './bulk/programming-arrows.svg';
import { ReactComponent as ReceiptBulk } from './bulk/receipt.svg';
import { ReactComponent as ReceiveSquare2Bulk } from './bulk/receive-square-2.svg';
import { ReactComponent as ScanBarcodeBulk } from './bulk/scan-barcode.svg';
import { ReactComponent as ScanBarcodeTranspBulk } from './bulk/scan-barcode-transp.svg';
import { ReactComponent as SendSqaure2Bulk } from './bulk/send-sqaure-2.svg';
import { ReactComponent as Shop1Bulk } from './bulk/shop-1.svg';
import { ReactComponent as ShopBulk } from './bulk/shop.svg';
import { ReactComponent as ShoppingBagBulk } from './bulk/shopping-bag.svg';
import { ReactComponent as ShoppingCartBulk } from './bulk/shopping-cart.svg';
import { ReactComponent as StoryBulk } from './bulk/story.svg';
import { ReactComponent as TagUserBulk } from './bulk/tag-user.svg';
import { ReactComponent as TickCircleBulk } from './bulk/tick-circle.svg';
import { ReactComponent as TrashBulk } from './bulk/trash.svg';
import { ReactComponent as UserOctagonBulk } from './bulk/user-octagon.svg';
import { ReactComponent as WalletAddBulk } from './bulk/wallet-add.svg';

export const CubeScanBulkIcon = (props) => <CubeScanBulk {...props} />;
export const ArrangeSquare2BulkIcon = (props) => <ArrangeSquare2Bulk {...props} />;
export const BankBulkIcon = (props) => <BankBulk {...props} />;
export const BubbleBulkIcon = (props) => <BubbleBulk {...props} />;
export const BuildingBulkIcon = (props) => <BuildingBulk {...props} />;
export const CloudAddBulkIcon = (props) => <CloudAddBulk {...props} />;
export const CoinBulkIcon = (props) => <CoinBulk {...props} />;
export const CourthouseBulkIcon = (props) => <CourthouseBulk {...props} />;
export const DangerBulkIcon = (props) => <DangerBulk {...props} />;
export const DiscountCircleBulkIcon = (props) => <DiscountCircleBulk {...props} />;
export const DollarCircleBulkIcon = (props) => <DollarCircleBulk {...props} />;
export const EmptyWalletTransparentBulkIcon = (props) => <EmptyWalletTransparentBulk {...props} />;
export const EmptyWalletBulkIcon = (props) => <EmptyWalletBulk {...props} />;
export const HomeTranspBulkIcon = (props) => <HomeTranspBulk {...props} />;
export const HomeBulkIcon = (props) => <HomeBulk {...props} />;
export const LocationBulkIcon = (props) => <LocationBulk {...props} />;
export const MessagesBulkIcon = (props) => <MessagesBulk {...props} />;
export const MobileBulkIcon = (props) => <MobileBulk {...props} />;
export const Money3BulkIcon = (props) => <Money3Bulk {...props} />;
export const MoneysBulkIcon = (props) => <MoneysBulk {...props} />;
export const MonitorMobbile1BulkIcon = (props) => <MonitorMobbile1Bulk {...props} />;
export const MonitorMobbileBulkIcon = (props) => <MonitorMobbileBulk {...props} />;
export const NotificationStatusBulkIcon = (props) => <NotificationStatusBulk {...props} />;
export const PersonalcardBulkIcon = (props) => <PersonalcardBulk {...props} />;
export const Profile2userBulkIcon = (props) => <Profile2userBulk {...props} />;
export const ProfileCircleTransparentBulkIcon = (props) => <ProfileCircleTransparentBulk {...props} />;
export const ProfileCircleBulkIcon = (props) => <ProfileCircleBulk {...props} />;
export const ProfileBulkIcon = (props) => <ProfileBulk {...props} />;
export const ProgrammingArrowsBulkIcon = (props) => <ProgrammingArrowsBulk {...props} />;
export const ReceiptBulkIcon = (props) => <ReceiptBulk {...props} />;
export const ReceiveSquare2BulkIcon = (props) => <ReceiveSquare2Bulk {...props} />;
export const ScanBarcodeBulkIcon = (props) => <ScanBarcodeBulk {...props} />;
export const ScanBarcodeTranspBulkIcon = (props) => <ScanBarcodeTranspBulk {...props} />;
export const SendSqaure2BulkIcon = (props) => <SendSqaure2Bulk {...props} />;
export const Shop1BulkIcon = (props) => <Shop1Bulk {...props} />;
export const ShopBulkIcon = (props) => <ShopBulk {...props} />;
export const ShoppingBagBulkIcon = (props) => <ShoppingBagBulk {...props} />;
export const ShoppingCartBulkIcon = (props) => <ShoppingCartBulk {...props} />;
export const StoryBulkIcon = (props) => <StoryBulk {...props} />;
export const TagUserBulkIcon = (props) => <TagUserBulk {...props} />;
export const TickCircleBulkIcon = (props) => <TickCircleBulk {...props} />;
export const TrashBulkIcon = (props) => <TrashBulk {...props} />;
export const UserOctagonBulkIcon = (props) => <UserOctagonBulk {...props} />;
export const WalletAddBulkIcon = (props) => <WalletAddBulk {...props} />;
